import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import OperationsProjectService from '../Services/OperationsProjectService';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import LongText from '../Elements/LongText';
import UserNameComponent from '../Elements/UserNameComponent';

class UserLinkItem
{
  constructor (item)
  {
    // console.log("UserGuidId in UserLinkItem constructor: ", item ? item.userGuidId : 'undefined');
    // console.log('Creating UserLinkItem with item: ', item);
    if (item === undefined)
    {
      this.UserlinkId = '';
      this.Title = '';
      this.Text = '';
      this.Url = '';
      this.Target = '';
      this.UserId = '';
      this.ForeColor = '';
      this.BackColor = '';
      this.IsActive = '';
      this.IsActiveText = '';
      this.Order = '';
      this.CreatedBy = '';
      this.CreatedOn = '';
      this.ModifiedBy = '';
      this.ModifiedOn = '';
      this.UserGuidId = '';


      return;
    }

    this.UserlinkId = item.userlinkId;
    this.Title = item.title;
    this.Text = item.text;
    this.Url = item.url;
    this.Target = item.target;
    this.UserId = item.userId;
    this.UserGuidId = item.userGuidId;
    this.ForeColor = item.foreColor;
    this.BackColor = item.backColor;
    this.IsActive = item.isActive;
    this.IsActiveText = item.isActive ? 'Yes' : 'No';
    this.Order = item.order;
    this.CreatedBy = item.createdBy;
    this.CreatedOn = item.createdOn;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedOn = item.modifiedOn;
    this.UserGuidId = item.userGuidId;
    // console.log('Created UserLinkItem: ', this);
  }

  static NameOfTheIdField ()
  {
    return 'UserlinkId';
  }
  static nameOfTheItemDetailList (item)
  {
    if (item) return <span>Link Details - {item.UserlinkId}</span>;
    return 'Project Details';
  }

  static FieldsToShowInDataTable ()
  {
    return [
      {
        label: 'Link ID',
        orderById: 'UserlinkId',
        data: 'UserlinkId',
      },
      {
        label: 'Title',
        orderById: 'Title',
        data: 'Title',
      },
      {
        label: 'Text',
        orderById: 'Text',
        data: (item) => (
          <LongText
            text={UserLinkItem.getTextCellContent(item)}
            maxLength={20}
          />)
      },
      {
        label: 'URL',
        orderById: 'Url',
        data: (item) => (
          <LongText
            text={item.Url}
            maxLength={20}
          />)
      },
      {
        label: 'Order',
        orderById: 'Order',
        data: 'Order',
      },
      {
        label: 'Active?',
        orderById: 'IsActive',
        data: 'IsActiveText',
      },
      {
        label: 'User',
        orderById: 'User',
        data: (item) => <UserNameComponent userId={item.UserGuidId} />,
      },
      {
        label: ' ',
        orderById: 'EvFraudGroup',
        data: UserLinkItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getTextCellContent (item)
  {
    return (
      <LongText
        text={item.Text ? item.Text : ' '}
        maxLength={40}
      />
    );
  }

  static getActionsContent (item)
  {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => UserLinkItem.editFunction(item),
          },
          {
            iconName: 'fa-regular fa-trash-can',
            text: 'Remove',
            onClick: () => UserLinkItem.deleteFunction(item.UserlinkId, item),
          },
        ]}
      />
    );
  }

  static editFunction = (item) =>
  {
    alert('Empty function');
  };

  static deleteFunction = (id, item) =>
  {
    alert('Empty function');
  };

  static DateFields = [];

  static MoneyFields = [];

  static MoneyFieldsSecondary = [];

  static BoolFields = [];

  static serviceFunctionForListTable = (item) => OperationsProjectService.GetProjectById(item.UserlinkId);

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [ { name: 'UserlinkId', label: 'Link ID' } ],
    },
  ];

  static Currency ()
  {
    return '';
  }
  static CurrencySecondary ()
  {
    return '';
  }
}

export default UserLinkItem;
